import { render, staticRenderFns } from "./SpeciesInputForm.vue?vue&type=template&id=5b276bc3&scoped=true&"
import script from "./SpeciesInputForm.vue?vue&type=script&lang=js&"
export * from "./SpeciesInputForm.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesInputForm.vue?vue&type=style&index=0&id=5b276bc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b276bc3",
  null
  
)

export default component.exports